import ButtonDropdown from "@rio-cloud/rio-uikit/ButtonDropdown"
import { MenuItemProps } from "@rio-cloud/rio-uikit/MenuItem"
import { ReactElement, useState } from "react"
import { FormattedMessage } from "react-intl"
import { ConfirmationUploadDialog } from "./ConfirmationUploadDialog"
import type { ConfirmationUploadType } from "./confirmationUploadCsv"


export const ConfirmationUploadButtonDropdown = (): ReactElement | null => {
    const [selectedUploadType, setSelectedUploadType] = useState<ConfirmationUploadType>("MATERIAL")
    const [showDialog, setShowDialog] = useState(false)

    const openDialog = (uploadType: ConfirmationUploadType): void => {
        setSelectedUploadType(uploadType)
        setShowDialog(true)
    }

    const closeDialog = (): void => {
        setShowDialog(false)
    }

    const uploadItems: MenuItemProps[] = [
        {
            value: <FormattedMessage id="transportOrder.confirmationUpload.menu.materials"/>,
            onSelect: () => openDialog("MATERIAL"),
        },
        {
            value: <FormattedMessage id="transportOrder.confirmationUpload.menu.empties"/>,
            onSelect: () => openDialog("EMPTIES"),
        },
    ]

    return <>
        <ButtonDropdown
            title={<>
                <span className="uikit-icon icon-upload margin-right-5"/>
                <FormattedMessage id="transportOrder.confirmationUpload.title"/>
            </>}
            items={uploadItems}
        />

        <ConfirmationUploadDialog
            uploadType={selectedUploadType}
            show={showDialog}
            onClose={closeDialog}
        />
    </>
}
